import { useLocation } from "react-router-dom";
import { Phone } from "lucide-react";
import { buildWhatsappUrl, PHONE_TEL } from "../lib/whatsapp";

export default function FloatingActions() {
  const location = useLocation();
  // Project detail has its own sticky mobile CTA — raise floating buttons above it on mobile
  const onProjectDetail =
    /^\/projects\/[^/]+$/.test(location.pathname) &&
    !["ongoing", "completed"].includes(location.pathname.split("/")[2]);

  const mobileBottom = onProjectDetail ? "bottom-24" : "bottom-5";

  const waUrl = buildWhatsappUrl("Hello, I'd like to know more about Sanggavai Constructions.");
  return (
    <div
      data-testid="floating-actions"
      className={`fixed right-4 ${mobileBottom} md:right-8 md:bottom-8 z-40 flex flex-col gap-3`}
    >
      <a
        href={`tel:${PHONE_TEL}`}
        data-testid="floating-call-btn"
        aria-label="Call"
        className="h-12 w-12 md:h-14 md:w-14 rounded-full bg-white text-[#7A2E5D] border border-[#7A2E5D]/30 shadow-lg hover:shadow-xl hover:-translate-y-0.5 transition-all duration-300 flex items-center justify-center"
      >
        <Phone className="h-5 w-5 md:h-6 md:w-6" />
      </a>
      <a
        href={waUrl}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="floating-whatsapp-btn"
        aria-label="WhatsApp"
        className="h-12 w-12 md:h-14 md:w-14 rounded-full bg-[#25D366] text-white shadow-lg hover:shadow-xl hover:-translate-y-0.5 transition-all duration-300 flex items-center justify-center"
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor" aria-hidden>
          <path d="M20.52 3.48A11.78 11.78 0 0 0 12.01 0C5.39 0 .02 5.37.02 12a11.9 11.9 0 0 0 1.63 6.04L0 24l6.16-1.61A11.96 11.96 0 0 0 12.01 24C18.63 24 24 18.63 24 12c0-3.19-1.24-6.19-3.48-8.52zM12.01 21.8a9.77 9.77 0 0 1-4.99-1.37l-.36-.21-3.66.96.98-3.57-.23-.37A9.8 9.8 0 0 1 2.22 12c0-5.4 4.4-9.8 9.8-9.8a9.78 9.78 0 0 1 9.79 9.8c0 5.4-4.4 9.8-9.8 9.8zm5.4-7.32c-.3-.15-1.75-.86-2.02-.96-.27-.1-.47-.15-.67.15-.2.3-.78.96-.95 1.16-.18.2-.35.22-.65.07-.3-.15-1.25-.46-2.38-1.47-.88-.78-1.47-1.75-1.64-2.05-.18-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.03-.52-.08-.15-.67-1.6-.92-2.2-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.08-.8.37-.27.3-1.05 1.03-1.05 2.5 0 1.48 1.07 2.9 1.22 3.1.15.2 2.1 3.21 5.1 4.5.71.3 1.27.49 1.71.62.72.23 1.37.2 1.89.12.58-.09 1.75-.72 2-1.41.25-.7.25-1.29.18-1.41-.08-.13-.28-.2-.58-.35z"/>
        </svg>
      </a>
    </div>
  );
}
